import { HexGlyph } from "@/components/HexIcon";

const words = ["Encourage", "Serve", "Grow", "Thrive", "Overcome", "New Life", "Give", "Love", "Joyful in Hope", "Celebrate Life"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl font-medium italic tracking-wide text-cream/90 sm:text-3xl">
          {w}
        </span>
        <HexGlyph className="h-4 w-4 text-gold/70" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-gold/25 bg-ink py-5"
      data-testid="inspiration-marquee"
      aria-label="Encourage, Serve, Grow, Thrive, Overcome, New Life, Give, Love, Joyful in Hope"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
